import React from 'react'
import classNames from 'classnames'

import './index.scss'

interface SmallPlusButtonProps {
  onClick: () => void
  className: string
  title: string
  width?: string
}

const SmallPlusButton = ({ onClick, className, title, width }: SmallPlusButtonProps) => {
  const classes = classNames('small-plus-button', { [`${className}`]: className })

  return (
    <div style={{ width }} onClick={onClick} className={classes}>
      <span className="small-plus-button__icon" />
      <span className="small-plus-button__text">{title}</span>
    </div>
  )
}

export default SmallPlusButton
